import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Field } from 'redux-form';
import { withReduxForm } from 'redux-form/es/ReduxFormContext';
import AvatarPicker from './AvatarPicker';

class FilePickerConnected extends PureComponent {
  static contextTypes = {
    onFormChange: PropTypes.func,
  };

  static propTypes = {
    name: PropTypes.string,
  };

  static defaultProps = {
    name: undefined,
  }

  handleChange = onChange => (event) => {
    onChange(event);
    setTimeout(this.context.onFormChange, 0);
  }

  renderField = (field = {}) => (
    <AvatarPicker
      {...this.props}
      {...field.input}
      {...field.meta}
      onChange={this.handleChange(field.input.onChange)}
    />
  );

  render() {
    if (!this.props._reduxForm) { // eslint-disable-line no-underscore-dangle
      return (
        <AvatarPicker
          {...this.props}
        />
      );
    }

    return (
      <Field
        component={this.renderField}
        name={this.props.name}
      />
    );
  }
}

export default withReduxForm(FilePickerConnected)